import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";
import { IFileSchedulingFob } from "interfaces/order-fob";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_FILE_SCHEDULING_FOB_" }
);

export interface FetchFileSchedulingFobState extends IState {
  data: IFileSchedulingFob | null;
}

export interface FetchFileSchedulingFobSuccess extends ISuccessAction {
  data: IFileSchedulingFob;
}

const INITIAL_STATE: FetchFileSchedulingFobState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchFileSchedulingFobState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchFileSchedulingFobState, action: FetchFileSchedulingFobSuccess) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchFileSchedulingFobState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchFileSchedulingFob = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchFileSchedulingFobTypes = Types;
export const FetchFileSchedulingFobActions = Creators;
